var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnplCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 97,
    viewBox: "0 0 141 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bnpl_cal_clip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.998 92.7871H43.4985C39.923 92.7871 36.9977 89.8712 36.9977 86.3073V19.872C36.9977 16.308 39.923 13.3921 43.4985 13.3921H127.998C131.574 13.3921 134.499 16.308 134.499 19.872V86.3073C134.499 89.8712 131.574 92.7871 127.998 92.7871Z",
    fill: "#CFD5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.345 19.497V27.8484H34.8433V19.497C34.8433 16.125 38.0693 13.3916 42.0455 13.3916H125.139C129.118 13.3916 132.345 16.125 132.345 19.497Z",
    fill: "#AFCAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.345 58.1815V87.1324C132.345 90.2538 129.119 92.7864 125.139 92.7864H42.0455C38.0693 92.7864 34.8433 90.2538 34.8433 87.1324V63.4604V27.7397H132.344L132.345 58.1815Z",
    fill: "#FDFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3854 22.3871C63.7288 22.3871 64.8178 21.2364 64.8178 19.8171C64.8178 18.3977 63.7288 17.2471 62.3854 17.2471C61.0419 17.2471 59.9529 18.3977 59.9529 19.8171C59.9529 21.2364 61.0419 22.3871 62.3854 22.3871Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4027 20.9407H62.3682C61.5134 20.9407 60.8204 20.2499 60.8204 19.3979V9.68731C60.8204 8.83529 61.5134 8.14453 62.3682 8.14453H62.4027C63.2574 8.14453 63.9504 8.83529 63.9504 9.68731V19.3979C63.9504 20.2499 63.2574 20.9407 62.4027 20.9407Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7667 22.3871C51.1101 22.3871 52.1992 21.2364 52.1992 19.8171C52.1992 18.3977 51.1101 17.2471 49.7667 17.2471C48.4233 17.2471 47.3342 18.3977 47.3342 19.8171C47.3342 21.2364 48.4233 22.3871 49.7667 22.3871Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.784 20.9407H49.7495C48.8948 20.9407 48.2018 20.2499 48.2018 19.3979V9.68731C48.2018 8.83529 48.8948 8.14453 49.7495 8.14453H49.784C50.6388 8.14453 51.3318 8.83529 51.3318 9.68731V19.3979C51.3318 20.2499 50.6388 20.9407 49.784 20.9407Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1442 22.3871C77.4876 22.3871 78.5766 21.2364 78.5766 19.8171C78.5766 18.3977 77.4876 17.2471 76.1442 17.2471C74.8007 17.2471 73.7117 18.3977 73.7117 19.8171C73.7117 21.2364 74.8007 22.3871 76.1442 22.3871Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1615 20.9407H76.127C75.2722 20.9407 74.5792 20.2499 74.5792 19.3979V9.68731C74.5792 8.83529 75.2722 8.14453 76.127 8.14453H76.1615C77.0162 8.14453 77.7092 8.83529 77.7092 9.68731V19.3979C77.7092 20.2499 77.0162 20.9407 76.1615 20.9407Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9034 22.3871C91.2469 22.3871 92.3359 21.2364 92.3359 19.8171C92.3359 18.3977 91.2469 17.2471 89.9034 17.2471C88.56 17.2471 87.4709 18.3977 87.4709 19.8171C87.4709 21.2364 88.56 22.3871 89.9034 22.3871Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9205 20.9407H89.886C89.0313 20.9407 88.3383 20.2499 88.3383 19.3979V9.68731C88.3383 8.83529 89.0313 8.14453 89.886 8.14453H89.9205C90.7753 8.14453 91.4683 8.83529 91.4683 9.68731V19.3979C91.4683 20.2499 90.7753 20.9407 89.9205 20.9407Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.662 22.3871C105.005 22.3871 106.094 21.2364 106.094 19.8171C106.094 18.3977 105.005 17.2471 103.662 17.2471C102.318 17.2471 101.229 18.3977 101.229 19.8171C101.229 21.2364 102.318 22.3871 103.662 22.3871Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.679 20.9407H103.645C102.79 20.9407 102.097 20.2499 102.097 19.3979V9.68731C102.097 8.83529 102.79 8.14453 103.645 8.14453H103.679C104.534 8.14453 105.227 8.83529 105.227 9.68731V19.3979C105.227 20.2499 104.534 20.9407 103.679 20.9407Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.421 22.3871C118.765 22.3871 119.854 21.2364 119.854 19.8171C119.854 18.3977 118.765 17.2471 117.421 17.2471C116.078 17.2471 114.989 18.3977 114.989 19.8171C114.989 21.2364 116.078 22.3871 117.421 22.3871Z",
    fill: "#D7E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.439 20.9407H117.404C116.549 20.9407 115.856 20.2499 115.856 19.3979V9.68731C115.856 8.83529 116.549 8.14453 117.404 8.14453H117.439C118.293 8.14453 118.986 8.83529 118.986 9.68731V19.3979C118.986 20.2499 118.293 20.9407 117.439 20.9407Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7666 38.9346H40.6448V46.3691H49.7666V38.9346Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7668 50.7471H40.6448V58.1816H49.7668V50.7471Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7668 62.5596H40.6448V69.9941H49.7668V62.5596Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7668 74.3716H40.6448V81.8061H49.7668V74.3716Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5622 38.9346H53.4404V46.3691H62.5622V38.9346Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5622 50.7471H53.4404V58.1816H62.5622V50.7471Z",
    fill: "#5998F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5622 62.5596H53.4404V69.9941H62.5622V62.5596Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5622 74.3716H53.4404V81.8061H62.5622V74.3716Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3588 38.9346H66.2368V46.3691H75.3588V38.9346Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3588 50.7471H66.2368V58.1816H75.3588V50.7471Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3588 62.5596H66.2368V69.9941H75.3588V62.5596Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3588 74.3716H66.2368V81.8061H75.3588V74.3716Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.155 38.9346H79.033V46.3691H88.155V38.9346Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.155 50.7471H79.033V58.1816H88.155V50.7471Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.155 62.5596H79.033V69.9941H88.155V62.5596Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.155 74.3716H79.033V81.8061H88.155V74.3716Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.951 38.9346H91.8289V46.3691H100.951V38.9346Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.951 50.7471H91.8289V58.1816H100.951V50.7471Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.951 62.5596H91.8289V69.9941H100.951V62.5596Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.951 74.3716H91.8289V81.8061H100.951V74.3716Z",
    fill: "#DCE7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.747 62.5596H104.625V69.9941H113.747V62.5596Z",
    fill: "#AFCAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.747 38.9346H104.625V46.3691H113.747V38.9346Z",
    fill: "#AFCAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.747 50.7471H104.625V58.1816H113.747V50.7471Z",
    fill: "#AFCAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.747 74.3716H104.625V81.8061H113.747V74.3716Z",
    fill: "#AFCAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.543 74.3716H117.421V81.8061H126.543V74.3716Z",
    fill: "#AFCAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.543 38.9346H117.421V46.3691H126.543V38.9346Z",
    fill: "#AFCAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.543 50.7471H117.421V58.1816H126.543V50.7471Z",
    fill: "#AFCAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.543 62.5596H117.421V69.9941H126.543V62.5596Z",
    fill: "#AFCAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5343 57.2722L54.8711 53.7179L55.7144 53.0126L57.5235 55.4269L60.2808 51.6504L61.1324 52.3446L57.5343 57.2722Z",
    fill: "#FDFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.055 93.1088H42.0448C37.8956 93.1088 34.5203 90.4282 34.5203 87.1331V45.1104H35.1665V87.1331C35.1665 90.0728 38.2521 92.4646 42.0448 92.4646H128.055V93.1088H128.055Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.668 54.3774H132.022V68.4962H132.668V54.3774Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.668 40.8342H132.022V19.4964C132.022 16.308 128.935 13.714 125.14 13.714H42.0451C40.6594 13.714 39.3231 14.0597 38.181 14.7137C36.2937 15.7946 35.1669 17.5824 35.1669 19.4964H34.5206C34.5206 17.349 35.7685 15.3523 37.8589 14.1552C39.0989 13.4452 40.5465 13.0698 42.0451 13.0698H125.14C129.291 13.0698 132.668 15.9527 132.668 19.4964V40.8342Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9528 43.5948C46.1003 44.0996 45.6459 44.5748 45.135 44.45L38.2998 42.7813C36.2484 44.0193 33.8424 44.7307 31.2686 44.7307C23.7547 44.7307 17.6624 38.658 17.6624 31.1669C17.6624 23.6772 23.7547 17.6045 31.2686 17.6045C38.784 17.6045 44.8763 23.6772 44.8763 31.1669C44.8763 33.0077 44.5084 34.7635 43.8403 36.3638L45.9528 43.5948Z",
    fill: "#FFC76C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3793 39.2519C43.8585 34.7871 43.8585 27.5482 39.3792 23.0833C34.8999 18.6185 27.6375 18.6184 23.1583 23.0832C18.679 27.548 18.6791 34.787 23.1584 39.2518C27.6377 43.7167 34.9 43.7167 39.3793 39.2519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0335 32.8382L31.686 30.8015L28.3715 22.9607C28.2971 22.7844 28.1247 22.6704 27.9329 22.6704C27.8691 22.6704 27.8069 22.6829 27.7482 22.7077C27.5062 22.8092 27.3923 23.088 27.4942 23.3292L30.6219 30.7282L22.0381 28.1979C22.0162 28.1916 21.9935 28.1882 21.9707 28.1882C21.8642 28.1882 21.7699 28.2596 21.7412 28.3617C21.7063 28.486 21.7788 28.617 21.903 28.6536L30.8612 31.2942L30.9031 31.3934L30.8581 31.5329L30.9784 31.5715L31.0233 31.6775L31.1471 31.6256L37.7418 33.7415C37.7892 33.7566 37.8382 33.7644 37.8878 33.7644C38.0952 33.7644 38.2773 33.6322 38.3409 33.4352C38.4211 33.1862 38.2832 32.9183 38.0335 32.8382Z",
    fill: "#3B4F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.779 91.5488C121.819 88.6391 123.538 82.2079 120.619 77.1843C117.7 72.1607 111.248 70.4472 106.208 73.3569C101.168 76.2667 99.449 82.6979 102.368 87.7214C105.287 92.745 111.739 94.4586 116.779 91.5488Z",
    fill: "#FFC76C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.997 86.3524C120.153 82.7702 118.987 78.1242 115.393 75.9753C111.8 73.8264 107.139 74.9883 104.983 78.5705C102.827 82.1527 103.993 86.7987 107.586 88.9476C111.18 91.0965 115.841 89.9345 117.997 86.3524Z",
    fill: "#FFE9AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.222 87.4622C111.526 87.5519 110.94 87.4439 110.464 87.138C109.987 86.8322 109.648 86.3566 109.446 85.7116L109.238 85.0474L111.012 84.4954L111.251 85.2606C111.435 85.8479 111.851 86.0405 112.499 85.8389C113.148 85.6373 113.377 85.2329 113.187 84.6268C113.069 84.2512 112.849 83.9474 112.527 83.7151C112.204 83.4825 111.673 83.2599 110.932 83.0467C110.011 82.7737 109.327 82.4637 108.881 82.1163C108.436 81.7693 108.125 81.3164 107.95 80.7579C107.754 80.1325 107.761 79.5652 107.97 79.0565C108.178 78.5478 108.587 78.1302 109.196 77.8034L108.92 76.9226L110.456 76.4448L110.731 77.3256C111.427 77.2359 112.01 77.3426 112.479 77.6453C112.948 77.9485 113.284 78.4224 113.486 79.0672L113.576 79.3558L111.803 79.9079L111.68 79.5181C111.493 78.9214 111.087 78.7204 110.462 78.915C109.836 79.1095 109.614 79.4956 109.795 80.0732C109.904 80.4197 110.117 80.7045 110.437 80.9269C110.756 81.15 111.288 81.3727 112.031 81.5954C112.956 81.8781 113.642 82.1953 114.089 82.5474C114.536 82.8994 114.85 83.364 115.031 83.9416C115.236 84.5963 115.231 85.1868 115.015 85.7135C114.799 86.24 114.38 86.6639 113.757 86.9844L114.074 87.9949L112.539 88.4727L112.222 87.4622Z",
    fill: "#FFC76C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.907 77.973C104.693 78.3709 105.233 78.9818 105.603 79.7469C105.973 78.9818 106.516 78.3677 107.302 77.9696C106.516 77.5717 105.973 76.9609 105.603 76.1958C105.233 76.9611 104.692 77.5752 103.907 77.973Z",
    fill: "#EEF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.191 82.6231C106.648 82.8544 106.962 83.2093 107.177 83.6538C107.392 83.2093 107.707 82.8525 108.164 82.6212C107.707 82.39 107.392 82.035 107.177 81.5903C106.962 82.035 106.648 82.3919 106.191 82.6231Z",
    fill: "#EEF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.602 92.7061H28.6021V93.2415H140.602V92.7061Z",
    fill: "#3B4F5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bnpl_cal_clip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.602,
    height: 96.8169,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnplCalendar);
export default __webpack_public_path__ + "static/media/bnpl-calendar.b79dd48ba11783ac5d333bd4c4bac010.svg";
export { ForwardRef as ReactComponent };